import { render, staticRenderFns } from "./WhatsappEmbeddedSignup.vue?vue&type=template&id=486d962e&scoped=true&"
import script from "./WhatsappEmbeddedSignup.vue?vue&type=script&lang=js&"
export * from "./WhatsappEmbeddedSignup.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappEmbeddedSignup.vue?vue&type=style&index=0&id=486d962e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d962e",
  null
  
)

export default component.exports